import React from 'react';
import { once } from '../../utils/func';
import ReactDOM from 'react-dom';
import { getFirstFocusableElement } from '../../utils/dom';
import EventNotifications from './EventNotifications';
import { PAGE_LOAD } from '../../api/redux-jigsaw/jigsaw-events';
import { MODAL_OPENED } from 'app/api/events';

export default class SetFocusOnPageLoad extends React.Component {
  state = {
    blocked: false,
  };

  componentDidMount() {
    document.addEventListener(MODAL_OPENED, this.modalOpened);
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
    document.removeEventListener(MODAL_OPENED, this.modalOpened);
  }

  modalOpened = () => {
    this.setState({
      blocked: true,
    });
  };

  focusAfterTimeout = once(() => {
    this.timeoutId = setTimeout(() => {
      const container = ReactDOM.findDOMNode(this);
      const toFocus = getFirstFocusableElement(container);
      if (toFocus) {
        toFocus.focus();
      }
    }, 100);
  });

  render() {
    return (
      <React.Fragment>
        {this.props.children}
        {!this.state.blocked && (
          <EventNotifications
            events={[PAGE_LOAD]}
            onJigsawEvent={this.focusAfterTimeout}
            retryInterval={10}
          />
        )}
      </React.Fragment>
    );
  }
}
